import { makeAutoObservable, observable, action } from 'mobx';
import { cloneDeep, urlParse } from '@block/utils';
import { getCity, getBG, getJF, getHIRING, getEnCityList } from '../service/social';
import formatSearchEum from '../utils/formatSearchEum';

class JobCommon {
  city;

  bgData;

  jfData;

  hiringData;

  /** 校园招聘类型 */
  campusHiringData;
  /** 零食管培生招聘类型 */
  foodRetailManagementHiringData;
  /** 招聘专场招聘类型 */
  specialHiring;

  hiringBeidouData;

  hiringLongcatData;

  hiringQihangData;

  enCityData;

  @observable keyword = '';

  constructor() {
    makeAutoObservable(this);
  }

  // 将北斗计划的招聘码转换为 LongCat 的招聘码
  // 北斗: 1-3, 2-3 -> LongCat: 1-8, 2-8
  private transformBeidouToLongcat = (data) => {
    const cloned = cloneDeep(data);
    return cloned?.map((item) => {
      const newItem = { ...item };
      if (item.children) {
        newItem.children = item.children.map((child) => {
          const newChild = { ...child };
          // 将 1-3 转换为 1-8, 2-3 转换为 2-8
          if (child.code === '1-3') {
            newChild.code = '1-8';
          } else if (child.code === '2-3') {
            newChild.code = '2-8';
          }
          return newChild;
        });
      }
      return newItem;
    });
  };

  // 页面筛选数据初始化
  @action
  initData = async () => {
    const [
      cityData,
      bgData,
      jfData,
      hiringData,
      campusHiringData,
      hiringBeidouData,
      hiringLongcatData,
      foodRetailManagementHiringData,
      specialHiring,
      enCityData,
    ] = await Promise.all([
      getCity({
        hotCity: true,
      }),
      getBG().catch(),
      getJF().catch(),
      /** 了解美团招聘类型 */
      getHIRING('NEW_HIRING').catch(),
      /** 校园招聘招聘类型 */
      getHIRING('CAMPUS_HIRING').catch(),
      /** 北斗招聘类型 */
      getHIRING('NEW_BEIDOU_HIRING').catch(),
      /** LongCat 招聘类型 */
      getHIRING('NEW_BEIDOU_HIRING').catch(),
      /** 零售启航计划招聘类型 */
      getHIRING('FOOD_RETAIL_MANAGEMENT_HIRING').catch(),
      /** 招聘专场招聘类型 */
      getHIRING('CAMPUS_SPECIAL_HIRING').catch(),
      getEnCityList(),
    ]);
    this.bgData = bgData;
    // jf的code带上父级jg的code
    this.jfData = formatSearchEum(jfData, true);
    this.campusHiringData = formatSearchEum(campusHiringData, false);
    this.foodRetailManagementHiringData = formatSearchEum(foodRetailManagementHiringData, false);
    this.specialHiring = formatSearchEum(specialHiring, false);

    // 招聘类型 子节点的id带上父节点的id
    // const isCampus = ['/m/campus']?.includes(window?.location?.pathname);
    // if (isCampus) {
    //   this.hiringData = formatSearchEum(
    //     hiringData?.filter((item) => item.code !== '3'),
    //     false,
    //   );
    // } else {
    //   this.hiringData = formatSearchEum(hiringData, false);
    // }
    this.hiringData = formatSearchEum(hiringData, false);

    this.hiringBeidouData = formatSearchEum(hiringBeidouData, false);
    // LongCat 使用 NEW_BEIDOU_HIRING 接口，但需要将码从 1-3,2-3 转换为 1-8,2-8
    this.hiringLongcatData = formatSearchEum(this.transformBeidouToLongcat(hiringLongcatData), false);
    // this.hiringQihangData = formatSearchEum(hiringQihangData, false);
    // 社招伯乐页面无 其他
    const currentQueryInfo = urlParse(window?.location?.search);
    if (window?.location?.pathname === '/m/share-position' && currentQueryInfo?.jobShareType === '2') {
      this.setCity(cityData?.filter((item) => item?.code !== 'other'));
    } else {
      this.setCity(cityData);
    }
    const normalizeEnCityData =
      enCityData?.map((item) => {
        const _children = item.children ?? [];
        const children =
          _children.length <= 1
            ? _children
            : [
                {
                  code: '-1',
                  name: '全部',
                  children: null,
                },
                ..._children,
              ];
        return {
          ...item,
          children,
        };
      }) ?? [];
    this.setEnCity(normalizeEnCityData);
  };

  @action
  setCity = (city) => {
    this.city = city;
  };

  @action
  setEnCity = (city) => {
    this.enCityData = city;
  };
}

const JobCommonStore = new JobCommon();

export default JobCommonStore;
